import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import BlockIcon from '@material-ui/icons/Block';
import classnames from 'classnames';
import Grid from '@material-ui/core/Grid';
import { useTranslation } from '../../src/i18n';
import { colors } from '../../constants/styleConstants';
import { TP } from '../../constants/consts';

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    flex: 'none',
    flexWrap: 'nowrap',
    [theme.breakpoints.down('md')]: {
      flexWrap: 'wrap',
    },
    [theme.breakpoints.down('xs')]: {
      flexWrap: 'wrap',
    },
    '& > *': {
      marginRight: theme.spacing(0.5),
    },
  },
  chip: {
    opacity: '0.7',
    borderRadius: '4px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '3px',
    height: '1rem',
    flexShrink: 0,
  },
  chipText: {
    fontWeight: 'bold',
    color: colors.white,
    fontSize: '10px',
    textTransform: 'uppercase',
  },
  iconSize: {
    fontSize: '10px',
    fontWeight: 'bold',
    color: colors.white,
  },
  liveEvent: {
    backgroundColor: colors.greenChip,
  },

  cancelled: {
    backgroundColor: colors.purple,
  },
  mediaOnly: {
    backgroundColor: colors.blueChip,
  },
  archived: {
    backgroundColor: 'rgba(108,108,108, 0.7)',
  },
}));

const PerformanceTypeChips = ({ className, chipType }) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const content = (() => {
    switch (chipType) {
      case 'live':
        return (
          <div className={classnames(classes.chip, classes.liveEvent)}>
            <span className={classes.chipText}>{t(`${TP}.PERFORMANCE_LIVE_EVENT`)}</span>
          </div>
        );
      case 'media':
        return (
          <div className={classnames(classes.chip, classes.mediaOnly)}>
            <span className={classes.chipText}>{t(`${TP}.PERFORMANCE_MEDIA_ONLY`)}</span>
          </div>
        );
      case 'cancelled':
        return (
          <div className={classnames(classes.chip, classes.cancelled)}>
            <BlockIcon className={classes.iconSize} />
            <span className={classes.chipText}>&nbsp;{t(`${TP}.PERFORMANCE_CANCELLED`)}</span>
          </div>
        );
      case 'archived':
        return (
          <div className={classnames(classes.chip, classes.archived)}>
            <span className={classes.chipText}>{t(`${TP}.ARCHIVED`)}</span>
          </div>
        );
      default:
        return null;
    }
  })();

  return (
    <Grid item className={classnames(classes.root, className)}>
      {content}
    </Grid>
  );
};

PerformanceTypeChips.propTypes = {
  className: PropTypes.string,
  chipType: PropTypes.string,
};

export default memo(PerformanceTypeChips);
